import { graphql } from '@/generated/gql';

export const GET_RULE_DATA = graphql(/* GraphQL */ `
  query GetRuleData($id: UUID!) {
    tesseract {
      rule(id: $id) {
        id
        name
        responsibleUsers
        variant
      }
    }
  }
`);
